// extracted by css-extract-rspack-plugin
export default {"imageContainer":"ContentfulBackgroundImage-module__imageContainer__CLa03","expandFalse":"ContentfulBackgroundImage-module__expandFalse__Knate"};